import { Link, LinkProps } from '@dtx-company/design-system/src'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { USER_ALREADY_EXIST_ERROR_MESSAGE } from '@dtx-company/true-common/src/constants/auth'
import React from 'react'
import type { FronteggSignupError } from '@dtx-company/ithaca-sdk/src/frontegg/error'

const customErrorText =
  "Signup failed. Please double check the information you've entered and try again. If you are an existing user, please "

const signinLinkText = 'sign in'

interface FronteggErrorMessageProps {
  error: FronteggSignupError
  onSignInClick?: React.MouseEventHandler<HTMLElement>
  hideSignInLink?: boolean
}

export const FronteggErrorMessage: React.FC<FronteggErrorMessageProps> = ({
  error,
  onSignInClick,
  hideSignInLink
}) => {
  if (error.message === USER_ALREADY_EXIST_ERROR_MESSAGE) {
    // Hide this error from the user to reduce username enumeration vulnerability.
    // We've asked fontegg to change this error message to something more generic, but hide it here in the meantime.

    const linkProps: LinkProps = onSignInClick
      ? {
          onClick: onSignInClick
        }
      : {
          href: Routes.SIGN_IN
        }

    return (
      <>
        {customErrorText}{' '}
        {hideSignInLink ? signinLinkText : <Link {...linkProps}>{signinLinkText}</Link>}.
      </>
    )
  }
  return <>{error.message}</>
}
